import { render, staticRenderFns } from "./HotTabContent.vue?vue&type=template&id=993b2798&scoped=true"
import script from "./HotTabContent.vue?vue&type=script&lang=js"
export * from "./HotTabContent.vue?vue&type=script&lang=js"
import style0 from "./HotTabContent.vue?vue&type=style&index=0&id=993b2798&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "993b2798",
  null
  
)

export default component.exports